export default __webpack_public_path__ + "static/media/NOKO_2.9619d28c.gif";